import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { TextBox } from 'srcReact/components/common2/TextBox'
import { useTranslation } from 'react-i18next'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import PasswordTextBox from 'srcReact/components/common2/PasswordTextBox'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'
import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import { isEmail } from 'srcReact/helpers/validator'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { redirectToPage } from 'srcReact/helpers/history'

function AuthorizeExternalApp(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const urlParam = useParams()

  const {
    common: { isNative },
    authentication: {
      authExternalApp: { loading, success, error, redirectUrl }
    }
  } = useSelector((state) => state)

  const [emailRef, setEmailRef] = useState(null)
  const [email, setEmail] = useState({
    name: 'email',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const [passwordRef, setPasswordRef] = useState(null)
  const [password, setPassword] = useState({
    name: 'password',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  useEffect(() => {
    if ((!loading && success, redirectUrl)) {
      window.location.href = redirectUrl
    }
  }, [success, loading, redirectUrl])

  const handleEmailChange = (event) => {
    if (event) {
      const { value } = event.target
      setEmail({ ...email, value: value, hasError: false, errorMessage: '' })
    }
  }
  const handlePasswordChange = (event) => {
    if (event) {
      const { value } = event.target
      setPassword({ ...password, value: value })
    }
  }

  const handleConfirm = () => {
    if (validate()) {
      let queryParam = queryString.parse(location.search)
      if (queryParam && urlParam) {
        const code = queryParam.code
        const appName = urlParam.app
        dispatch(authenticationActions.loginWithApp(email.value, password.value, appName, code))
      }
    }
  }
  const validate = () => {
    const emailValue = email.value
    const passWordValue = password.value
    if (!emailValue) {
      setEmail({
        ...email,
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.email`) })
      })
      return false
    } else if (!isEmail(emailValue)) {
      setEmail({
        ...email,
        hasError: true,
        errorMessage: t('error.invalid_email')
      })
      return false
    }
    if (!passWordValue) {
      setPassword({
        ...password,
        hasError: true,
        errorMessage: t('error.required', { field: t(`global.password`) })
      })
      return false
    }
    return true
  }

  return (
    <PageContainer withFooter={false} isPlainBanner={true}>
      <div className={styles.login}>
        <div className={styles.loginContainer}>
          <div className={styles.loginLeft}>
            <p className={styles.loginText}>{t('login.quote')}</p>
          </div>
          <div className={styles.loginRight}>
            <h1 className={styles.title}>{t('login.authWithMixr')}</h1>
            {/* <h2 className={styles.subTitle}>{t('login.email.subTitle')}</h2> */}
            <div className={styles.form}>
              <TextBox
                label={t('formlabel.enterEmail')}
                inputType='text'
                isRequired={true}
                fieldInfo={email}
                onChange={handleEmailChange}
                name='email'
                placeholder='e.g. John@mail.com'
                setRef={setEmailRef}
                customWrapperCss={styles.emailWrapper}
              />

              <PasswordTextBox
                label={t('formlabel.enterPswd')}
                value={password.value}
                placeholder={t('global.password')}
                handleChange={handlePasswordChange}
                containerClassName={styles.passwordWrapper}
                direction='column'
                isRequired={true}
                errorMessage={password.errorMessage}
                setRef={setPasswordRef}
              />

              <div className={styles.buttons}>
                <Button text={t('global.confirm')} handleClick={handleConfirm} customStyle={styles.confirmBtn} />
                {loading && <Spinner customCss={styles.spinner} />}
              </div>
              {error && <ErrorMessage text={error} className={styles.error} center={true} />}
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  )
}

export default AuthorizeExternalApp
